module.exports = "https://99designs-start-assets.imgix.net/js/aa462c69e9a1e9901075243285a4d5f1.png";